/**
 * @file Identity Update reducer.
 */

import {
  IDENTITY_UPDATE_REQUEST,
  IDENTITY_UPDATE_SUCCESS,
  IDENTITY_UPDATE_FAILURE,
  IDENTITY_UPDATE_RESET,
} from '../actions/identity-update';

const initialState = {
  loading: false,
  error: '',
  success: false,
};

const identityUpdateReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case IDENTITY_UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        success: false,
      };

    case IDENTITY_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        success: true,
      };

    case IDENTITY_UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        success: false,
      };

    case IDENTITY_UPDATE_RESET:
      return initialState;

    default:
      return state;
  }
};

export { initialState };
export default identityUpdateReducer;
